import { ColorHex } from '@carboncopyco/ui';
import { integersFormatter, secondsToHHmmss } from '@carboncopyco/utils';
import { StatsCard } from '../../StatsCard';
import { useGetTotalsData } from '../../hooks';

const title = 'Sandbox visits';

export const TotalVisits = () => {
  const {
    data,
    isLoading,
    isLoadingPrevData,
    getPercentages,
    getDescription,
    chartData,
    isError,
  } = useGetTotalsData({
    resourceTypes: ['shared_presentation'],
    assetType: 'demo',
  });

  const { values } = data ?? {};

  return (
    <StatsCard
      isError={isError}
      isEmpty={!isLoading && !values?.occurrences}
      title={title}
    >
      <StatsCard.Graph
        title={title}
        kpiNumber={
          values?.occurrences ? integersFormatter(values.occurrences) : ''
        }
        kpiPercentage={getPercentages('occurrences')}
        kpiRawNumber={values?.occurrences}
        description={getDescription('occurrences')}
        lineChartData={chartData}
        loading={isLoading || isLoadingPrevData}
        negative={getPercentages('occurrences') < 0}
        color={ColorHex.accent1200}
      />
      <StatsCard.Item
        title="Median duration"
        value={
          values?.medianDuration ? secondsToHHmmss(values.medianDuration) : ''
        }
        loading={isLoading || isLoadingPrevData}
        percentage={getPercentages('medianDuration')}
        negative={getPercentages('medianDuration') < 0}
        description={getDescription('medianDuration')}
      />
      <StatsCard.Item
        title="Avg. screens visited"
        value={
          values?.avgScreensVisited
            ? integersFormatter(values.avgScreensVisited)
            : ''
        }
        loading={isLoading}
      />
    </StatsCard>
  );
};
